import React, { FunctionComponent } from "react";
import ReanalyzeFormInput, {
  LAYOUT_TYPE
} from "../reanalyze-form-input/ReanalyzeFormInput";
import ReanalyzeCardContainer from "../reanalyze-card-container/ReanalyzeCardContainer";
import { AnalysisTypeInfo } from "../../../../header/hooks/usePrepareReanalyzeData";

type ReanalyzeAuxiliaryFormInputProps = {
  analysisInfo: AnalysisTypeInfo;
  selected: boolean;
  onToggle: (fieldName: string) => void;
  disabled?: boolean;
};

const ReanalyzeAuxiliaryFormInput: FunctionComponent<
  ReanalyzeAuxiliaryFormInputProps
> = ({ analysisInfo, selected, onToggle, disabled }) => {
  const isDisabled =
    !analysisInfo.enabled || analysisInfo.queue_filled || disabled;

  return (
    <ReanalyzeCardContainer
      disabled={isDisabled}
      selected={selected}
      layout={LAYOUT_TYPE.ROW}
      onClick={() => {
        if (isDisabled) {
          return;
        }
        onToggle("rl_auxiliary_analysis");
      }}
      tooltipMessage={
        isDisabled ? analysisInfo.additional_information : undefined
      }
      classNameOuterContainer={"mb-10"}
    >
      <ReanalyzeFormInput
        name="rl_auxiliary_analysis"
        label="Auxiliary Analysis"
        labelIcon="auxiliary-analysis"
        labelIconSize={24}
        helpImportant={
          isDisabled ? undefined : analysisInfo.additional_information
        }
        timestamp={analysisInfo.last_completed_on}
        disabled={isDisabled}
        layout={LAYOUT_TYPE.ROW}
        checked={selected}
      />
    </ReanalyzeCardContainer>
  );
};

export default ReanalyzeAuxiliaryFormInput;
